const GLOBAL_STYLES = 'global-styles';

export function prefixCSSRules(rules: CSSRuleList, prefix: string) {
  const arr: string[] = [];

  for (const rule of Object.values(rules)) {
    if (rule instanceof CSSMediaRule) {
      const mediaRule = rule.conditionText
        ? rule.conditionText
        : rule.media.mediaText;

      const prefixedMediaRules = prefixCSSRules(rule.cssRules, prefix);
      arr.push(`@media ${mediaRule} {\r\t${prefixedMediaRules}\r}`);
    } else if (rule instanceof CSSStyleRule) {
      if (rule.selectorText.includes(GLOBAL_STYLES)) {
        arr.push(rule.cssText);
      } else {
        rule.selectorText = rule.selectorText
          .split(',')
          .map((selector) => `${prefix} ${selector}`)
          .join(',');

        arr.push(rule.cssText);
      }
    } else if (rule instanceof CSSImportRule) {
      arr.push(rule.cssText);
    }
  }

  return arr.join('\r\n');
}
